export const CONNECTION_GAMES = [
    [
        {
            category: "Faculty Retiring This Year",
            words: ["Mumma", "Davis", "Andrews", "Murphy"],
            difficulty: 2,
        },
        {
            category: "Doubles as a Coach",
            words: ["Tretola", "Tull", "Sorensen", "Lopez"],
            difficulty: 3,
        },
        {
            category: "Chemistry Teachers",
            words: ["Charles", "Kenniff", "Ditta", "Papagni"],
            difficulty: 1,
        },
        {
            category: "Teachers with the First Name Michelle",
            words: ["Sellers", "Atkins", "Cawley", "Mahepath"],
            difficulty: 4,
        },
    ],
];
